import { useEffect } from 'react';

const PREFIX = 'Admin';

/**
 * Set the document title for admin pages. Prefixes with "Admin: ".
 * No meta description – admin is not for public indexing.
 *
 * @param {string} title - Page title (e.g. "Dashboard" → "Admin: Dashboard")
 */
export default function AdminPageTitle({ title }) {
  useEffect(() => {
    document.title = title ? `${PREFIX}: ${title}` : PREFIX;
  }, [title]);

  return null;
}
